<script setup>
import { onMounted, ref } from 'vue'
import { RouterLink, RouterView, useRouter } from 'vue-router'
import { store } from './store'
import LoginDialog from './components/LoginDialog.vue'
const router = useRouter()
const menuOpen = ref(false), loginOpen = ref(false), accountOpen = ref(false)
const loggedIn = ref(Boolean(localStorage.getItem('token')))
const loginSuccess = async () => {
  loggedIn.value = true
  loginOpen.value = false
  await store.loadProfile().catch(() => {})
}
const logout = () => {
  store.logout(); loggedIn.value = false; accountOpen.value = false
  if (router.currentRoute.value.meta.auth) router.push('/')
}
onMounted(() => {
  store.load().catch(() => { store.ready = true })
  if (loggedIn.value) store.loadProfile().catch(() => { store.logout(); loggedIn.value = false })
})
</script>
<template>
  <header class="site-header">
    <div class="nav-shell">
      <RouterLink to="/" class="brand" aria-label="尔数创研首页"><span class="brand-mark">尔</span><span>{{ store.site.brandName || '尔数创研' }}</span></RouterLink>
      <button class="menu-button" @click="menuOpen = !menuOpen" aria-label="打开导航">☰</button>
      <nav :class="{ open: menuOpen }" @click="menuOpen = false">
        <RouterLink to="/">首页</RouterLink><RouterLink to="/beginner">零基础专区</RouterLink><RouterLink to="/copyright">软著申请</RouterLink><RouterLink to="/projects">项目中心</RouterLink><RouterLink to="/deploy">部署服务</RouterLink><RouterLink to="/about">关于我们</RouterLink>
      </nav>
      <div class="nav-actions"><RouterLink class="member-link" to="/member">会员中心</RouterLink><button v-if="!loggedIn" class="button button-small" @click="loginOpen = true">小程序登录</button><div v-else class="account-menu" @mouseenter="accountOpen = true" @mouseleave="accountOpen = false"><button class="account-trigger" @click="accountOpen = !accountOpen" :aria-expanded="accountOpen"><span class="account-avatar"><img v-if="store.profile?.avatar" :src="store.profile.avatar" alt=""><b v-else>{{ (store.profile?.nickName || '用户').slice(0,1) }}</b></span><span class="account-name">{{ store.profile?.nickName || '个人中心' }}</span><i aria-hidden="true">⌄</i></button><div v-if="accountOpen" class="account-dropdown"><RouterLink to="/profile" @click="accountOpen=false">个人中心</RouterLink><RouterLink to="/member" @click="accountOpen=false">会员权益</RouterLink><button @click="logout">退出登录</button></div></div></div>
    </div>
  </header>
  <main>
    <RouterView v-slot="{ Component, route }">
      <Transition name="page" mode="out-in">
        <div class="route-view" :key="route.path"><component :is="Component" /></div>
      </Transition>
    </RouterView>
  </main>
  <footer><div><strong>{{ store.site.brandName || '尔数创研' }}</strong><p>清楚沟通，可靠交付，持续支持。</p></div><div><span>© {{ new Date().getFullYear() }} {{ store.site.companyName || '尔数科技' }}</span><span>照片与项目资料仅用于明确授权的服务流程</span></div></footer>
  <LoginDialog v-if="loginOpen" @close="loginOpen = false" @success="loginSuccess" />
</template>
